import React, { useState, createRef } from 'react';
import Rules from '../../utils/validation_rules';
import classnames from 'classnames';

const Checkbox = (props) => {
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const input = createRef(null);

    const validate = () => {
        let isValid = true;
        let message = props.errorMessage || '';
        let rules = props.validators;
        if (props.required) {
            rules = [Rules.isChecked, ...props.validators];
        }

        if (!input.current.value && !props.required) {
            setIsValid(isValid);
            setErrorMessage(message);

            return isValid;
        }

        rules.every((rule) => {
            let { func, name, msg } = rule;
            let test = func(input.current);
            isValid = isValid && test;
            message = props[`${name}Msg`] || props.validatorMsg || msg;
            return isValid;
        });

        setIsValid(isValid);
        setErrorMessage(message);
        return isValid;
    };

    const handleChange = (e) => {
        if (!isValid) {
            validate();
        }
        props.onChange(props.id, input.current.checked);
    };

    let errors = null;

    if (!isValid) {
        errors = (
            <div className="errors-list">
                <span>{errorMessage}</span>
            </div>
        );
    }

    return (
        <div
            className={classnames('form-group form-check', props.className, {
                'checkbox-inline': props.inline
            })}
        >
            <input
                className={classnames('form-check-input', {
                    success: isValid,
                    error: !isValid
                })}
                ref={input}
                checked={props.checked}
                value={props.value}
                type="checkbox"
                name={props.name || props.id}
                id={props.id}
                required={props.required}
                onChange={handleChange}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
            <label
                htmlFor={props.id}
                className={classnames('form-check-label', {
                    required: props.required
                })}
            >
                {props.label || props.children}
            </label>
            {errors}
        </div>
    );
};
export default Checkbox;
